var _circle, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoModalPoint4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#EAEFFC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(8 8)",
    fill: "#EAEFFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14.5C7 12.0312 9 10 11.5 10C13.9688 10 16 12.0312 16 14.5V20C16 21.125 15.0938 22 14 22H9C7.875 22 7 21.125 7 20V14.5ZM9 14.5C9 14.7812 9.21875 15 9.5 15H13.5C13.75 15 14 14.7812 14 14.5C14 14.25 13.75 14 13.5 14H9.5C9.21875 14 9 14.25 9 14.5ZM17 14.5C17 12.6562 16.0625 11 14.6562 10H20.5C22.9688 10 25 12.0312 25 14.5V20C25 21.125 24.0938 22 23 22H16.2188C16.6875 21.4688 17 20.7812 17 20V14.5ZM19 14.5C19 14.7812 19.2188 15 19.5 15H21V16.5C21 16.7812 21.2188 17 21.5 17H22.5C22.75 17 23 16.7812 23 16.5V14.5C23 14.25 22.75 14 22.5 14H21.5H19.5C19.2188 14 19 14.25 19 14.5Z",
    fill: "#3063E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoModalPoint4);
export default __webpack_public_path__ + "static/media/info-modal-point4.908368f23077d6f46b70f1f85c072ccc.svg";
export { ForwardRef as ReactComponent };